import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const Card = forwardRef(({ children, className, slim, noShadow, editable, hovering, style }, ref) => (
    <div
        ref={ref}
        className={cx('card', {
            'card--slim': slim,
            'card--no-shadow': noShadow,
            'card--editable': editable,
            'card--hovering': hovering,

        }, className)}
        style={style}
    >
        {children}
    </div>
));
Card.propTypes = {
    slim: PropTypes.bool,
    hovering: PropTypes.bool,
    noShadow: PropTypes.bool,
    editable: PropTypes.bool
};
Card.defaultProps = {
    slim: false,
    hovering: false,
    noShadow: false,
    editable: false,
};
export default Card;
